import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DataService } from 'src/app/services/data.service';
import { Router ,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-payment-medium',
  templateUrl: './payment-medium.component.html',
  styleUrls: ['./payment-medium.component.css'],
  animations: [
      trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class PaymentMediumComponent {
  product:any
  PayMediumList:any
  productList:any
  columnsCreditDisplay: string[] = ['paymentMedium','official','personal'];
  expandedElement!: any | null;
  mediumData:any={

    status:[]
  }
  activeList:any
id:any=0
constructor( private route :ActivatedRoute,private data:DataService,private PaymentConfigService:PaymentConfigService , private toastMsgService : ToastmsgService,){
  this.route.queryParams.subscribe(params => {
    let data:any
    data=params
    if(data.id){

    this.id=this.decodeTransformedcode(data.id)
    if(this.id==='paymentConfigNull'){
      this.id=null
    }
    }
  })
  this.getMediumActive()

  this.ProductList()
}
decodeTransformedcode(encodedEmail: string): string {
  let result = '';

  for (let i = 0; i < encodedEmail.length; i += 2) {
    const hexChar = encodedEmail.slice(i, i + 2);
    const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
    result += String.fromCharCode(charCode);
  }

  return result;
}

element:any=[]
onChangemedium(element:any){
this.element=element.value


}
mediumlist:any[]=[]

onAddMedium(){
  const label: any = this.element.map((item: string) => {
    let mediumName = item;
    let isBusinessEnabled = "false";
    let isPersonalEnabled = "false";

    return {
      mediumName,
      isBusinessEnabled,
      isPersonalEnabled
      
    };
  });



  for(let i=0;i<label.length;i++){

  this.mediumlist.push(label[i])

  }
  this.mediumlist=this.transformData(this.mediumlist)
  this.mediumData.status=this.mediumlist
  this.activeList= this.activeList.filter((item: any) => !this.element.includes(item));
  this.element=[]
}

transformData(inputData: any[]): any[] {
 
  return inputData.map(item => {
    return { ...item};
  });
}
onChangeProduct(event:any){
  let request:any={}
  request["userUid"]=this.id
  request["product"]=event.value
  this.mediumList(request)
}
mediumList(request:any){

  this.PaymentConfigService
  .paymentMediumList(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     
    
     for(let i=0 ;i<data.status.length;i++){
     data.status[i].isBusinessEnabled=data.status[i].isBusinessEnabled.toString()
     data.status[i].isPersonalEnabled=data.status[i].isPersonalEnabled.toString()
     }
    this.mediumData=data
    this.mediumlist=this.mediumData?.status

    if(this.mediumlist.length>0){
for(let i=0 ;i<this.mediumlist.length;i++){

        this.activeList = this.activeList.filter(
          (item: any) => this.mediumlist[i].mediumName !== item
        );
      
    }
    
    }

      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


ProductList(){

  this.PaymentConfigService
  .productList()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.productList=data

     this.product= this.productList[0]
     let request:any={}
  request["userUid"]=this.id
  request["product"]=this.product
  this.mediumList(request)


      } else {
      
      } 
    },error : (err) => {

    }
    
  }
)
}

getMediumActive(){

  this.PaymentConfigService
  .getMediumActive()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.activeList=data
     
    
 
      } else {
      
      } 
    },error : (err) => {

    }
    
  }
)
}
savePaymentMedium(){
    this.mediumData.userUid=this.id
 
  this.PaymentConfigService.savepaymentMedium(this.mediumData)
  .subscribe({
    next : (res) => {
      if(res.status==200 || res.status==201) {
        this.toastMsgService.setMsg({msg : "Payment Medium Saved Successfully!",msgTitle : "Success", msgType : "I"});
      this.ProductList()

      } else {
        const body : any = res.body;
        this.registerMediumErrorMsg(res.status,body?.result);
      } 

    },error : (err) => {

      this.registerMediumErrorMsg(err.status,err.error);
    }
  }
)
}

registerMediumErrorMsg(status : number,msg : string) {
if(status >=500) {
  this.toastMsgService.setMsg({msg : "Failed to save Payment Medium",msgTitle : "Warning", msgType : "W"});
} else {

  this.toastMsgService.setMsg({msg : "Failed to save Payment Medium",msgTitle:  "Warning", msgType : "W"});
} 
}


}
